import React from "react";
import BaseModal from "./BaseModal";
import { useBatchReplaceTags } from "show/list/hooks/apis";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

interface Props {
  tags: server.dto.TagSmall[]
  mainArea: server.dto.MainAreas
  onClose: () => void
}

const ReplaceTagsModal = (props: Props) => {
  const [selectedTags, setSelectedTags] = React.useState<number[]>([]);

  const selectedTagSet = new Set(selectedTags);

  const replaceTagsMutation = useBatchReplaceTags(props.mainArea);

  const applyChanges = async () => replaceTagsMutation.mutateAsync(selectedTags);
  return <BaseModal
    mainArea={props.mainArea}
    action="change"
    onClose={props.onClose}
    title={RESX.Tag.ReplaceTags}
    hasSelectedValue={selectedTags.length > 0}
    api={applyChanges}
  >
    {/* Padding bottom here is needed as for some reason,the height of this div is always 2px off, meaning the scrollbar will always show */}
    <div style={{ maxHeight: "50vh", overflow: "auto" }} className="padding-bottom-mini">
      {props.tags.map(tag => <div className="margin-top-small" key={tag.tagId}>
        <Checkbox
          checked={selectedTagSet.has(tag.tagId)}
          label={tag.title}
          onChange={(_, checked) => {
            if (checked) {
              setSelectedTags([...selectedTags, tag.tagId]);
            } else {
              setSelectedTags(selectedTags.filter(t => t !== tag.tagId));
            }
          }}
        />
      </div>)}
    </div>
  </BaseModal>;
};

export default ReplaceTagsModal;